export default __webpack_public_path__ + "static/media/TESTIMONI-CUT AGUSTIAWATI.455d8fbc.jpg";